var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { InputEventType } from "./InputManager.js";
const LeftStick = {
  id: {
    x: 0,
    y: 0,
    width: 960,
    height: 1080
  },
  index: 0,
  type: "joystick",
  key: ["w", "a", "s", "d"]
};
const RightStick = {
  id: {
    x: 960,
    y: 0,
    width: 960,
    height: 1080
  },
  index: 0,
  type: "joystick",
  key: ["i", "j", "k", "l"]
};
const SingleStick = {
  id: {
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  },
  index: 0,
  type: "joystick",
  key: ["w", "a", "s", "d"]
};
const LeftDoubleTap = {
  id: {
    x: 0,
    y: 0,
    width: 960,
    height: 1080
  },
  index: 0,
  type: "doubletap",
  key: "space"
};
const RightDoubleTap = {
  id: {
    x: 960,
    y: 0,
    width: 960,
    height: 1080
  },
  index: 0,
  type: "doubletap",
  key: "space"
};
const TwinStickDoubleTap = [LeftStick, RightStick, LeftDoubleTap, RightDoubleTap];
const PreconfiguredTouchRegions = {
  TwinStickDoubleTap,
  SingleStick: [SingleStick]
};
class TouchListener {
  constructor(inputManager) {
    __publicField(this, "regions", []);
    __publicField(this, "touchStart", null);
    __publicField(this, "lastTouch", null);
    __publicField(this, "lastTap", null);
    __publicField(this, "activeTouches", /* @__PURE__ */ new Map());
    __publicField(this, "lastTouchs", /* @__PURE__ */ new Map());
    __publicField(this, "lastTouchTimes", /* @__PURE__ */ new Map());
    __publicField(this, "touchStarts", /* @__PURE__ */ new Map());
    __publicField(this, "touchStartTimes", /* @__PURE__ */ new Map());
    __publicField(this, "lastTapTimes", /* @__PURE__ */ new Map());
    __publicField(this, "noContext", (e) => {
      e.preventDefault();
    });
    __publicField(this, "handleTouchMove", (e) => {
      e.preventDefault();
      for (const touch of Array.from(e.changedTouches)) {
        this.activeTouches.set(touch.identifier, touch);
        this.handletouch(e.timeStamp, touch, "move");
      }
    });
    __publicField(this, "handleTouchStart", (e) => {
      e.preventDefault();
      for (const touch of Array.from(e.changedTouches)) {
        this.activeTouches.set(touch.identifier, touch);
        this.handletouch(e.timeStamp, touch, "start");
      }
    });
    __publicField(this, "handleTouchEnd", (e) => {
      e.preventDefault();
      for (const touch of Array.from(e.changedTouches)) {
        this.activeTouches.set(touch.identifier, touch);
        this.handletouch(e.timeStamp, touch, "end");
      }
    });
    this.inputManager = inputManager;
    const interactionDiv = document.getElementById("interaction");
    interactionDiv.addEventListener("touchstart", this.handleTouchStart);
    interactionDiv.addEventListener("touchend", this.handleTouchEnd);
    interactionDiv.addEventListener("touchmove", this.handleTouchMove);
    interactionDiv.addEventListener("contextmenu", this.noContext);
  }
  assignRegion(region) {
    this.regions.push(region);
    return () => {
      this.regions = this.regions.filter((r) => r !== region);
    };
  }
  replaceRegions(regions) {
    this.regions = regions;
  }
  destroy() {
    const interactionDiv = document.getElementById("interaction");
    interactionDiv.removeEventListener("touchstart", this.handleTouchStart);
    interactionDiv.removeEventListener("touchend", this.handleTouchEnd);
    interactionDiv.removeEventListener("touchmove", this.handleTouchMove);
    interactionDiv.removeEventListener("contextmenu", this.noContext);
  }
  handletouch(timestamp, touch, prefix) {
    if (prefix === "start") {
      this.touchStarts.set(touch.identifier, touch);
      this.touchStartTimes.set(touch.identifier, timestamp);
    }
    this.regions.forEach((region) => {
      if (region.type === "tap") {
        this.handleTap(region, touch, timestamp, prefix);
      } else if (region.type === "joystick") {
        this.handleJoystick(region, touch, timestamp, prefix);
      } else if (region.type === "dpad")
        ;
      else if (region.type === "longpress") {
        this.handleLongPress(region, touch, timestamp, prefix);
      } else if (region.type === "doubletap") {
        this.handleDoubleTap(region, touch, timestamp, prefix);
      }
    });
    this.lastTouchs.set(touch.identifier, touch);
    this.lastTouchTimes.set(touch.identifier, timestamp);
    if (prefix === "end") {
      this.activeTouches.delete(touch.identifier);
      this.touchStarts.delete(touch.identifier);
      this.lastTouchs.delete(touch.identifier);
      this.lastTouchTimes.delete(touch.identifier);
      this.touchStartTimes.delete(touch.identifier);
    }
  }
  inRegion(region, touch) {
    if (!touch) {
      return false;
    }
    const normalizedX = touch.clientX * (1920 / window.innerWidth);
    const normalizedY = touch.clientY * (1080 / window.innerHeight);
    return normalizedX >= region.id.x && normalizedX <= region.id.x + region.id.width && normalizedY >= region.id.y && normalizedY <= region.id.y + region.id.height;
  }
  handleTap(region, touch, timestamp, prefix) {
    if (prefix === "start") {
      return;
    }
    if (prefix === "end") {
      if (this.inRegion(region, this.lastTouchs.get(touch.identifier))) {
        if (timestamp - this.touchStartTimes.get(touch.identifier) < 500) {
          this.inputManager.dispatchEvent(region.key, true, InputEventType.TOUCH, region.index);
          setTimeout(
            () => this.inputManager.dispatchEvent(region.key, false, InputEventType.TOUCH, region.index),
            100
          );
        }
      }
    }
  }
  handleDoubleTap(region, touch, timestamp, prefix) {
    if (prefix === "start") {
      return;
    }
    const tapKey = `${region.id.x}_${region.id.y}_${region.id.width}_${region.id.height}`;
    if (prefix === "end") {
      if (this.inRegion(region, this.lastTouchs.get(touch.identifier))) {
        if (!this.lastTapTimes.has(tapKey) || this.lastTouchTimes.get(touch.identifier) - this.lastTapTimes.get(tapKey) > 500) {
          this.lastTapTimes.set(tapKey, timestamp);
          return;
        }
        if (timestamp - this.touchStartTimes.get(touch.identifier) < 500) {
          this.inputManager.dispatchEvent(region.key, true, InputEventType.TOUCH, region.index);
          setTimeout(
            () => this.inputManager.dispatchEvent(region.key, false, InputEventType.TOUCH, region.index),
            100
          );
          this.lastTapTimes.delete(tapKey);
        }
      }
    }
  }
  handleLongPress(region, touch, timestamp, prefix) {
    if (prefix === "start") {
      return;
    }
    if (prefix === "end") {
      if (this.inRegion(region, this.lastTouchs.get(touch.identifier))) {
        if (timestamp - this.touchStartTimes.get(touch.identifier) > 500) {
          this.inputManager.dispatchEvent(region.key, true, InputEventType.TOUCH, region.index);
          setTimeout(
            () => this.inputManager.dispatchEvent(region.key, false, InputEventType.TOUCH, region.index),
            100
          );
        }
      }
    }
  }
  handleJoystick(region, touch, timestamp, prefix) {
    if (prefix === "start") {
      return;
    }
    const angleToKey = (angle, region2) => {
      while (angle < 0) {
        angle += Math.PI * 2;
      }
      const a = angle / (Math.PI * 2);
      const UP = region2.key[0];
      const LEFT = region2.key[1];
      const DOWN = region2.key[2];
      const RIGHT = region2.key[3];
      if (a > 0.9375 || a < 0.0625) {
        return [RIGHT];
      } else if (a < 0.1875) {
        return [DOWN, RIGHT];
      } else if (a < 0.3125) {
        return [DOWN];
      } else if (a < 0.4375) {
        return [DOWN, LEFT];
      } else if (a < 0.5625) {
        return [LEFT];
      } else if (a < 0.6875) {
        return [UP, LEFT];
      } else if (a < 0.8125) {
        return [UP];
      } else {
        return [UP, RIGHT];
      }
    };
    const keysFromTouch = (touch2, touchStart2, region2) => {
      const dx = touch2.clientX - touchStart2.clientX;
      const dy = touch2.clientY - touchStart2.clientY;
      const angle = Math.atan2(dy, dx);
      const distance = Math.sqrt(dx * dx + dy * dy);
      const maxDistance = Math.min(region2.id.width, region2.id.height) / 2;
      const normalizedDistance = Math.min(distance / maxDistance, 1);
      if (normalizedDistance > (region2.id.deadzone ?? 0)) {
        if (Array.isArray(region2.key)) {
          const keys = angleToKey(angle, region2);
          if (region2.skew) {
            let baseIndex = 1;
            let relativeAngle = angle;
            if (angle > 45) {
              baseIndex = 0;
              relativeAngle = 90 - angle;
            }
            let altIndex = baseIndex === 0 ? 1 : 0;
            let activeKeys = [];
            let value = dx;
            let altValue = dy;
            if (relativeAngle < region2.skew.zone[1]) {
              let index = value < 0 ? baseIndex * 2 : baseIndex * 2 + 1;
              let key = region2.key[index];
              if (Math.abs(value) > (region2.id.deadzone ?? 0)) {
                activeKeys.push(key);
              }
              if (relativeAngle > region2.skew.zone[0]) {
                if (Math.abs(altValue) > (region2.id.deadzone ?? 0)) {
                  activeKeys.push(region2.skew.keys[altValue < 0 ? 0 : 1]);
                }
              }
            } else {
              if (Math.abs(value) > (region2.id.deadzone ?? 0)) {
                activeKeys.push(region2.key[value < 0 ? baseIndex * 2 : baseIndex * 2 + 1]);
              }
              if (Math.abs(altValue) > (region2.id.deadzone ?? 0)) {
                activeKeys.push(region2.key[altValue < 0 ? altIndex * 2 : altIndex * 2 + 1]);
              }
            }
            return activeKeys;
          } else {
            return keys;
          }
        }
        return [region2.key];
      }
      return [];
    };
    const touchStart = this.touchStarts.get(touch.identifier);
    const lastTouch = this.lastTouchs.get(touch.identifier);
    if (this.inRegion(region, touchStart) || prefix === "end") {
      const lastKeys = lastTouch ? keysFromTouch(lastTouch, touchStart, region) : [];
      const keys = keysFromTouch(touch, touchStart, region);
      let keysDown = keys.filter((k) => !lastKeys.includes(k));
      let keysUp = lastKeys.filter((k) => !keys.includes(k));
      if (prefix === "end") {
        keysUp = lastKeys;
        keysDown = [];
      }
      keysDown.forEach((key) => {
        this.inputManager.dispatchEvent(key, true, InputEventType.TOUCH, region.index);
      });
      keysUp.forEach((key) => {
        this.inputManager.dispatchEvent(key, false, InputEventType.TOUCH, region.index);
      });
      return;
    }
  }
}
export {
  LeftDoubleTap,
  LeftStick,
  PreconfiguredTouchRegions,
  RightDoubleTap,
  RightStick,
  SingleStick,
  TouchListener
};
//# sourceMappingURL=TouchListener.js.map
